import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=411cf244&"
import script from "./Text.vue?vue&type=script&lang=ts&"
export * from "./Text.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports